<template>
  <centered-box v-if="success">
    <b-col >
      <b-card border-variant="primary" class="thankYouCard">
        <div class="thankYouDiv">
          Thank You For Your Quote!
        </div>
      </b-card>
    </b-col>
  </centered-box>
  <div v-else>
    <h1 class="bd-title" id="content">
      RFQ
      <small v-if="public_rfq">{{ public_rfq.label }}</small>
    </h1>
    <div class="form">
      <rfq-form
        v-bind:request="public_rfq"
        v-bind:response="public_rfq_response"
        v-on:submit="onSubmit"
        v-bind:loading="loading"
      />
    </div>
    <confirmation-dialog v-model="confirmation" v-on:ok="onConfirm">
      <div>
        <quote-read v-bind:response="public_rfq_response" v-bind:hideEdit="true"/>
      </div>
    </confirmation-dialog>
  </div>
</template>

<script>
import RfqForm from '@/components/rfqs/Form';
import ConfirmationDialog from '@/components/common/ConfirmationDialog';
import QuoteRead from "@/components/quotes/Read";
import CenteredBox from '@/components/common/CenteredBox';
import { datadogLogs } from '@datadog/browser-logs';

const PortalApi = require("@brightoncromwell/portal-api");
const public_rfqsApiInstance = new PortalApi.PublicRfqsApi();

export default {
  name: "public_rfq",
  metaInfo: {
    title: "PublicRfq"
  },
  components: {
    'rfq-form': RfqForm,
    'confirmation-dialog': ConfirmationDialog,
    "quote-read": QuoteRead,
    'centered-box': CenteredBox
  },
  data() {
    return {
        public_rfq: null,
        public_rfq_response: null,
        loading: false,
        success: false,
        confirmation: false
    };
  },
  methods: {
    createResponse: function(public_rfq) {
      let response = {
        fob: public_rfq.fob || '',
        ref_no: public_rfq.ref_no,
        expiration_ts: public_rfq.expiration_ts,
        comments: public_rfq.comments,
        lines: [],
        additional_costs: []
      };
      public_rfq.lines.forEach((rfq_line) => {
        let response_line = {
          id: rfq_line.id,
          nsn: rfq_line.nsn,
          part_number: null,
          description: rfq_line.description,
          no_quote_classification: rfq_line.no_quote_classification || null,
          coo: rfq_line.coo || '',
          weight_per_uom: rfq_line.weight_per_uom,
          minimum_order_quantity: rfq_line.minimum_order_quantity,
          will_advise_dt: rfq_line.will_advise_dt,
          quantities: [],
          additional_costs: [],
          disposition: '',
          alternate_nsn: { name: null, is_form_fit_function_match: null, description: null },
          alternate_part_number: { name: null, is_form_fit_function_match: null, description: null }
        };
        rfq_line.quantities.forEach((rfq_line_quantity) => {
          let response_line_quantity = {
            qty: rfq_line_quantity.qty,
            uom: rfq_line_quantity.uom,
            lead_time: rfq_line_quantity.lead_time,
            cost: rfq_line_quantity.cost,
            condition: rfq_line_quantity.condition,
            custom_fields: {},
            rfq_line_quantity_id: rfq_line_quantity.rfq_line_quantity_id,
            no_quote: rfq_line_quantity.no_quote
          };
          response_line.quantities.push(response_line_quantity);
        });
        response.lines.push(response_line);
      });
      return response;
    },
    getPublicRfq: function(id, link_id, code) {
      let opts = {
        'linkId': link_id,
        'code': code
      };
      public_rfqsApiInstance.publicRfqsIdGet(id, opts, (error, data, response) => {
        if (error) {
          datadogLogs.logger.error('getPublicRfq() failed', { rfqId: id,  error: error });
          console.error(error);
          this.$emit('onError', response, true)
        } else {
          datadogLogs.logger.info('getPublicRfq() succeeded', { rfqId: id });
          this.public_rfq = data;
          this.public_rfq_response = this.createResponse(this.public_rfq);
        }
      });
    },
    postPublicRfq: function(id, link_id, code, public_rfq_response) {
      this.loading = true;
      let opts = {
        'linkId': link_id,
        'code': code,
        'quoteResponse': public_rfq_response
      };
      public_rfqsApiInstance.publicRfqsIdPost(id, opts, (error, data, response) => {
        if (error) {
          console.error(error);
          datadogLogs.logger.error('postPublicRfq() failed', { rfqId: id,  error: error });
          this.$emit('onError', response)
        } else {
          //console.log('API called successfully.');
          datadogLogs.logger.info('postPublicRfq() succeeded', { rfqId: id });
          window.scrollTo(0,0);
          this.success = true
        }
        this.loading = false;
      });
    },
    onSubmit() {
        console.log(this.response);
        this.confirmation = true;
    },
    onConfirm() {
      let id = this.$route.params.id;
      let link_id = this.$route.params.link_id;
      let code = this.$route.params.code;
      let public_rfq_response = this.public_rfq_response;
      datadogLogs.logger.info('RFQ #' + this.public_rfq.label + ' confirmed and submitted', {});
      this.postPublicRfq(id, link_id, code, public_rfq_response);
    }
  },
  created() {
    let id = this.$route.params.id;
    let link_id = this.$route.params.link_id;
    let code = this.$route.params.code;
    console.log("public_rfqs/Edit.vue created");
    this.getPublicRfq(id, link_id, code);
  },
  mounted() {
    console.log("public_rfqs/Edit.vue mounted");
  }
};
</script>

<style scoped>
.thankYouDiv {
  text-align: center;
  color: #444444;
  size: 200%;
  font-weight: bold;
}

.thankYouCard {
  background-color: rgb(253, 217, 183);

  -webkit-box-shadow: 7px 10px 12px 0px rgba(176,176,176,1);
  -moz-box-shadow: 7px 10px 12px 0px rgba(176,176,176,1);
  box-shadow: 7px 10px 12px 0px rgba(176,176,176,1);
}
</style>